import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormCheck,
} from "@coreui/react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import {
  createCountry,
  getSingleCountry,
  updateCountry,
} from "../../services/country.services";
import { useParams } from "react-router-dom";

const schema = z.object({
  name: z.string().min(1, "Please type name"),
  code: z.string().min(1, "Please type code"),
});

const CreateCountryForm = () => {
  const { id } = useParams();
  const [countryId, setCountryId] = useState("");
  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );
  useEffect(() => {
    if (id) {
      setCountryId(id);
      getCountryInfo(id);
    }
    console.log("id======", id);
  }, [id]);

  const getCountryInfo = (id) => {
    // setIsLoading(true)
    getSingleCountry(id)
      .then(async (response) => {
        const { name, code } = response.data;
        setValue("name", name);
        setValue("code", code);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      code: "",
    },
    resolver: zodResolver(schema),
  });

  const onSubmit = (data) => {
    if (countryId) {
      toast
        .promise(
          updateCountry(data, countryId),
          {
            loading: "Loading",
            success: "Country Updated Succesfully",
            error: (err) => {
              return err.response &&
                err.response.data &&
                err.response.data.message
                ? err.response.data.message
                : defaultErrorMessage;
            },
          },
          {
            id: "country",
          }
        )
        .then(async (response) => {
          // console.log("response", response);
        })
        .catch((error) => console.error(error));
    } else {
      toast
        .promise(
          createCountry(data),
          {
            loading: "Loading",
            success: "Country Created Succesfully",
            error: (err) => {
              return err.response &&
                err.response.data &&
                err.response.data.message
                ? err.response.data.message
                : defaultErrorMessage;
            },
          },
          {
            id: "country",
          }
        )
        .then(async (response) => {
          // console.log("response", response);
          reset();
        })
        .catch((error) => console.error(error));
    }
  };

  const onError = (err) => {
    console.error(err);
  };

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CRow>
          <CCol sm={5}>
            <h4 id="traffic" className="card-title mb-0">
              {countryId ? "Edit Country" : "Create Country"}
            </h4>
          </CCol>
          <CCol sm={7} className="d-none d-md-block"></CCol>
        </CRow>
        <hr />
        <br />
        <CForm onSubmit={handleSubmit(onSubmit, onError)}>
          <CRow>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel htmlFor="name" className="col-sm-3 col-form-label">
                  Country Name:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput type="text" id="name" {...register("name")} />
                  {errors.name?.message && (
                    <p className="error_text">{errors.name?.message}</p>
                  )}
                </CCol>
              </CRow>
            </CCol>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel htmlFor="code" className="col-sm-3 col-form-label">
                  Country Code:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput type="text" id="code" {...register("code")} />
                  {errors.code?.message && (
                    <p className="error_text">{errors.code?.message}</p>
                  )}
                </CCol>
              </CRow>
            </CCol>

            <CRow className="mt-5">
              <div className="d-flex justify-content-end">
                <CButton
                  type="submit"
                  color="primary"
                  className="px-5 py-2 me-3"
                >
                  Submit
                </CButton>
              </div>
            </CRow>
          </CRow>
        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default CreateCountryForm;
